import {
  Controller
} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container-quantity"]

  handleQuantityChange() {
    var reg = /^\d+$/;
    let val = this.element.value

    if (!reg.test(val)) {
      this.element.parentElement.classList.add('formError')
        // $(this).val(val.replace(/[^\d]/g, ''))
    } else {
      this.element.parentElement.classList.remove('formError')
    }
  }
}